import { useQuery } from '@tanstack/react-query';
import { fetchAgentConversation, fetchCaseBrief } from '../api/agentChat';

export const useAgentConversation = (caseNumber, enabled = true) => {
  return useQuery({
    queryKey: ['agent-conversation', caseNumber],
    queryFn: () => fetchAgentConversation(caseNumber),
    enabled: !!caseNumber && enabled,
    staleTime: 30_000,
  });
};

/**
 * Fetches the case brief markdown once per open chat session.
 * The panel passes this back with each chat turn so the backend
 * doesn't need to rebuild it every request.
 */
export const useCaseBrief = (caseNumber, enabled = true) => {
  return useQuery({
    queryKey: ['case-brief', caseNumber],
    queryFn: () => fetchCaseBrief(caseNumber),
    enabled: !!caseNumber && enabled,
    staleTime: 5 * 60_000, // 5 min
    retry: 1,
  });
};
